<template>
  <div class="course-schedule">
    <courseScheduleTopbar
      @addCourseScheduleShowSwitch="addCourseScheduleShowSwitch"
      :gradePlaceholder="gradePlaceholder"
      :gradeSelectList="gradeSelectList"
      @selectGrade="selectGrade"
    />
    <courseScheduleTable
      @lessonPlanRefresh="lessonPlanRefresh"
      :gradeId="gradeId"
      :courseScheduleData="courseScheduleData"
    />
  </div>
</template>

<script>
import courseScheduleTopbar from "./components/course-schedule-topbar/courseScheduleTopbar.vue";
import courseScheduleTable from "./components/course-schedule-table/courseScheduleTable.vue";
export default {
  data() {
    return {
      courseScheduleListGetResult: "success",
      // 当前页码
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      // 是否显示添加课程表页面
      addCourseScheduleShow: false,
      // 总条数
      total: 1,
      // 课程表数据
      courseScheduleData: [],
      // 当前年级id
      gradeId: "",
      // 年级下拉框数据
      gradeSelectList: [],
      // 年级输入框提示文字
      gradePlaceholder: "请选择年级",
      days: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
    };
  },
  components: {
    courseScheduleTopbar,
    courseScheduleTable,
  },
  created() {
    this.selectSchoolAndGradeAndClassListPC();
  },
  methods: {
    lessonPlanRefresh(e) {
      this.gradeId = e;
      // 获取课程构建列表
      this.getCourseConstructionList();
    },
    // 切换年级
    selectGrade(e) {
      // 判断e是否为空
      if (!e) {
        // 设置年级选择框的提示信息
        this.gradePlaceholder = "请选择年级";
      }
      // 设置年级id
      this.gradeId = e;
      // 获取课程构建列表
      this.getCourseConstructionList();
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      // 获取年级列表
      this.get(this.$url.getgradeList, {
        // 获取当前用户学校id
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          // 判断响应状态
          if (res.code !== 200) {
            // 返回错误信息
            return this.$message.error(res.msg);
          }
          // 设置年级选择列表
          this.gradeSelectList = res.data;
          // 设置年级id
          this.gradeId = res.data[0].gradeId;
          // 设置年级选择框的提示信息
          this.gradePlaceholder = res.data[0].gradeName;
          // 获取课程构建列表
          this.getCourseConstructionList();
        })
        .catch((err) => {});
    },
    // 修改课程构建确认
    editConfirm(data) {
      // 解构赋值
      let { lessons, name, id, gradeId, startTime, endTime, noClassWeek } =
        data;
      // 修改课程构建
      this.put(this.$url.updateCourseConstruction, {
        // 获取课程构建id
        id,
        // 获取课程构建内容
        lessons,
        // 获取课程构建名称
        name,
        // 获取年级id
        gradeId,
        // 获取课程构建开始时间
        startTime,
        // 获取课程构建结束时间
        endTime,
        // 获取课程构建不上课的星期
        noClassWeek,
      }).then((res) => {
        // 判断响应状态
        if (res.code != 200) return this.$message.error(res.msg);
        // 返回成功信息
        this.$message.success("修改成功");
        // 关闭编辑框
        this.$refs.courseScheduleList.editShow = false;
        // 获取课程构建列表
        this.getCourseConstructionList();
      });
    },
    // 添加课程构建确认
    addConfirm(data) {
      // 解构赋值
      let { lessons, name, gradeId, startTime, endTime, noClassWeek } = data;
      // 添加课程构建
      this.post(this.$url.insertCourseConstruction, {
        // 获取课程构建内容
        lessons,
        // 获取课程构建名称
        name,
        // 获取年级id
        gradeId,
        // 获取课程构建开始时间
        startTime,
        // 获取课程构建结束时间
        endTime,
        // 获取课程构建不上课的星期
        noClassWeek,
      }).then((res) => {
        // 判断响应状态
        if (res.code != 200) return this.$message.error(res.msg);
        // 返回成功信息
        this.$message.success("添加成功");
        // 关闭添加框
        this.addCourseScheduleShow = false;
        // 获取课程构建列表
        this.getCourseConstructionList();
      });
    },
    // 切换添加课程构建显示状态
    addCourseScheduleShowSwitch(e) {
      // 设置添加课程构建显示状态
      this.addCourseScheduleShow = e;
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      // 设置当前页码
      this.pageInfo.pageNum = pageNum;
      // 获取课程构建列表
      this.getCourseConstructionList();
    },
    // 获取课程构建列表
    getCourseConstructionList() {
      // 设置请求参数
      let data = {
        // pageNum: this.pageInfo.pageNum,
        // pageSize: this.pageInfo.pageSize,
        gradeId: this.gradeId,
      };
      // 设置获取结果为loading
      this.courseScheduleListGetResult = "loading";
      // 发送请求
      this.get(this.$url.getCourseConstructionList, data).then((res) => {
        // console.log("获取课程计划表==>", res);
        // 判断响应状态
        if (res.code != 200) {
          // 设置获取结果为error
          this.courseScheduleListGetResult = "error";
          // 返回错误信息
          return this.$message.error("获取课程计划列表失败");
        }

        if (!res.data) {
          // 设置获取结果为error
          this.courseScheduleListGetResult = "nullData";
          this.courseScheduleData = [];
          // 返回错误信息
          return this.$message.warning("暂无课程计划");
        }
        // 设置课程构建列表
        this.courseScheduleData = this.convertApiDataToCourseSchedule(res.data);
        // console.log("获取课程计划表-转换后:", this.courseScheduleData);
        // 设置总记录数
        // this.total = res.total;
        // 判断总记录数是否大于0
        // this.total > 0
          // ? (this.courseScheduleListGetResult = "success")
          // : (this.courseScheduleListGetResult = "nullData");
      });
    },
    // 转换课程计划接口数据为 courseSchedule 格式

    convertApiDataToCourseSchedule(apiData) {
      const convertedData = [];

      // 使用数组来存储每个课程的数据
      const courseDataArray = [];

      for (const apiItem of apiData) {
        // 查找是否已存在相同的 lessonsName 的课程数据
        const existingCourseData = courseDataArray.find(
          (item) => item.startTime === apiItem.startTime
        );

        // 如果不存在，则创建新的课程数据
        if (!existingCourseData) {
          const courseData = {
            courseOrder: "",
            courseName: apiItem.lessonsName || "",
            courseTime: "",
            notAvailableName: false,
            startTime: apiItem.startTime,
            周一: { subject: "", notAvailable: false, placeholder: "" },
            周二: { subject: "", notAvailable: false, placeholder: "" },
            周三: { subject: "", notAvailable: false, placeholder: "" },
            周四: { subject: "", notAvailable: false, placeholder: "" },
            周五: { subject: "", notAvailable: false, placeholder: "" },
            周六: { subject: "", notAvailable: false, placeholder: "" },
            周日: { subject: "", notAvailable: false, placeholder: "" },
          };

          // 将新创建的课程数据添加到数组中
          courseDataArray.push(courseData);
        }

        // 查找或新创建的课程数据
        const courseData = courseDataArray.find(
          (item) => item.startTime === apiItem.startTime
        );

        // 填充数据
        courseData.courseOrder = apiItem.lessonsSequence || "";
        courseData.courseTime = [apiItem.startTime, apiItem.endTime] || "";
        courseData.notAvailableName = apiItem.status === "0";

        const dayIndex = apiItem.week - 1;

        if (dayIndex >= 0 && dayIndex < this.days.length) {
          const day = this.days[dayIndex];

          courseData[day].subject = apiItem.lessonContent || "";
          courseData[day].notAvailable = apiItem.status === "0";
          courseData[day].placeholder = courseData[day].notAvailable
            ? "填写自定义课程"
            : "";
        }
      }

      return courseDataArray;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./courseSchedule.scss";
</style>
